import { Component, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RouterOutlet } from '@angular/router';
import { FlightRequestComponent } from '../Flight/flight-request/flight-request.component';
import { LangPipe } from '../../Shared/pipes/lang.pipe';
import { CommonModule } from '@angular/common';
import { IndexedDbService } from '../../core/services/indexed-dbservice.service';
import { ApiService } from '../../core/services/api.service';
import { NotificationService } from '../../core/services/notification.service';
import { AppConstants_settings } from '../../core/AppConstants_Appsettings.enum';
import { SeoService } from '../../core/services/seo.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [RouterOutlet, FlightRequestComponent, LangPipe, CommonModule],
  templateUrl: './dashboard.component.html',
  providers: [LangPipe]
})
export class DashboardComponent {

  flightForm!: FormGroup;
  featuredFlights: any[] = [];
  loading: boolean[] = [];
  isMobile: boolean = false;
  imgUrl: any;
  channel: any = "B2C";
  constructor(private fb: FormBuilder, private router: Router, private dbService: IndexedDbService,
    private apiService: ApiService, private notification: NotificationService, private seo: SeoService) {
    this.imgUrl = environment.STATIC_IMAGES_URL;
    this.channel = AppConstants_settings.CHANNEL;
    this.initForm();
    this.loadFlightCards();
    this.checkDevice();
    window.scrollTo(0, 0);
  }
  ngOnInit() {

    this.seo.setPageSeo({
      title: 'Cheap Flights Booking | Compare Airlines – Taveelo',
      description: 'Book cheap flights and holiday packages. Compare airlines and save more.',
      url: window.location.href
    });
  }
  // -----------------------
  // FLIGHT FORM
  // -----------------------
  initForm() {
    this.flightForm = this.fb.group({
      tripType: ['roundtrip', Validators.required],
      cabinClass: ['economy', Validators.required],
      passengers: this.fb.group({
        adult: [1],
        child: [0],
        infant: [0]
      }),
      generalInfo: this.fb.group({
        companyId: [''],
        apiKey: [''],
        channel: ['B2C'],
        companyCurrency: [''],
        agencyCurrency: ['INR'],
        grossCurrency: ['INR'],
        companyDecimalPref: [2],
        addFlightMarkupInBaseFare: [true]
      }),
      FilterOptions: this.fb.group({
        ResultType: ['Combined'],
      }),
      from: [''],
      to: [''],
      departureDate: [''],
      returnDate: [''],
      ui_From: [''],
      ui_To: [''],
      ui_DepartureDate: [''],
      ui_ReturnDate: [''],
      multiOriginDestinations: this.fb.array([])
    });
  }

  // -----------------------
  // MAKE 4 CARDS DYNAMIC
  // -----------------------
  loadFlightCards() {
    let d1 = this.getDateAfter(3);
    let d2 = this.getDateAfter(5);

    this.featuredFlights = [
      {
        img: this.imgUrl + '/img/flight/01.png',
        titleFrom: "DXB",
        titleTo: "KWI",
        ui_from: "Dubai International Airport(DXB)",
        ui_to: "Kuwait International Airport(KWI)",
        price: 300,
        dep: d1,
        ret: d2
      },
      {
        img: this.imgUrl + '/img/flight/02.png',
        titleFrom: "DEL",
        titleTo: "SIN",
        ui_from: "Delhi Airport(DEL)",
        ui_to: "Singapore Airport(SIN)",
        price: 450,
        dep: this.getDateAfter(2),
        ret: this.getDateAfter(3)
      },
      {
        img: this.imgUrl + '/img/flight/03.png',
        titleFrom: "BOM",
        titleTo: "DXB",
        ui_from: "Mumbai Airport(BOM)",
        ui_to: "Dubai International Airport(DXB)",
        price: 520,
        dep: this.getDateAfter(4),
        ret: this.getDateAfter(6)
      },
      {
        img: this.imgUrl + '/img/flight/04.png',
        titleFrom: "MAA",
        titleTo: "DOH",
        ui_from: "Chennai Airport(MAA)",
        ui_to: "Doha Airport(DOH)",
        price: 630,
        dep: this.getDateAfter(3),
        ret: this.getDateAfter(7)
      }
    ];
  }

  // -----------------------
  // 3 DAYS AFTER DATE
  // -----------------------
  getDateAfter(days: number): string {
    let dt = new Date();
    dt.setDate(dt.getDate() + days);
    return dt.toISOString().substring(0, 10);
  }

  // -----------------------
  // WHEN USER CLICKS SEE DETAILS
  // -----------------------
  goToSearch(f: any, i: number) {
    this.flightForm.patchValue({
      from: f.titleFrom,
      to: f.titleTo,
      departureDate: f.dep,
      returnDate: f.ret,
      ui_From: f.ui_from,
      ui_To: f.ui_to,
      ui_DepartureDate: f.dep,
      ui_ReturnDate: f.ret
    });
    this.loading[i] = true;

    this.dbService.getData('userCurr').then(data => {
      const generalInfo = this.flightForm.get('generalInfo') as FormGroup;
      generalInfo.get('grossCurrency')?.setValue(data?.TargetCurrency || 'AED');
      generalInfo.get('agencyCurrency')?.setValue(data?.TargetCurrency || 'AED');
      generalInfo.get('channel')?.setValue(AppConstants_settings.CHANNEL || 'B2C');
      const payload = { ...this.flightForm.value };
      // this.apiService.generateToken().subscribe({
      //   next: () => {
      this.apiService.flightRequest(payload).subscribe({
        next: (res: any) => {
          this.loading[i] = false;
          if (res?.statuscode == 1) {
            this.dbService.setData('request-data', payload);
            const resultId = JSON.parse(res.jsondata).resultId;
            this.router.navigate(['/flight-response'], { queryParams: { resId: resultId } });
          }
        },
        error: err => {
          this.loading[i] = false;
          const msg = err?.error?.message || 'Something went wrong while searching flight';
          this.notification.error(msg);
        }
        // });
        // },
        // error: () => {
        //   this.loading = false;
        //   this.notification.error('Unable to generate token, try again.');
        // }
      });
    });
  }
  @HostListener('window:resize', ['$event'])
  isMobileDevice() {
    this.checkDevice();
  }

  checkDevice() {
    if (typeof window !== 'undefined') {
      this.isMobile = window.innerWidth <= 768;
    }
  }

}
